<template>
	<div style="background-color:#fffcf7;" class="container">
		<headMenu />
		<div
		class="w-100 overflow-hidden p-3 h-center">
			<div
				class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-3 border-15 shadow bg-white text-center"
				data-aos="flip-up"
				data-aos-easing="ease-out-cubic"
				data-aos-duration="2000"
				style="
				display: flex;
				align-items: center;
				justify-content: center;
				align-content: center;
				"
			>
				<div style="width: 80%;">
					<h2 class="text-center bMikhak">
						کد تایید کلاس امروز
					</h2>
					<p class="text-justify">
						مدرس گرامی؛
						لطفاً کد تایید کلاس خود را از کاربر دریافت و در قسمت پایین وارد نمایید.
					</p>
					
					<textInput
						autofocus="true"
						@inputTxtFunc="(e)=>{ res_pass = e; }"
						:val="res_pass"
						label="کد تایید کلاس "
					/>
					<btn @clickMe="getPass()" class="w-100 mt-3" textClass="w-100" text="ورود" />
				</div>
			</div>
		</div>
		<footerPage />
	</div>
</template>

<script>
	import textInput from  "../../../UI/input/textInput.vue";
	import footerPage from  "../../../UI/footer/footer.vue";
	import btn from  "../../../UI/button/btn.vue";
	import headMenu from  "../../../menu/headMenu.vue";
	import { error,success } from  "../../../assets/library/messege.js";
	
	export default {
			name: 'oneTimePassword_check_phone',
		data(){
			return {
				error: error,
				success: success,
				res_pass: "",
			}
		},
		components: {
			btn,
			textInput,
			headMenu,
			footerPage,
		},
		mounted(){
			this.$swal.close();
		},
		methods:{
			getPass(THIS = this){
				if(this.res_pass==""){
						THIS.error(THIS, 'کد تایید کلاس را وارد نمایید')
				}else{
					window.$.post(window.baseurl + "reserved/password", { password: this.res_pass, user: this.$route.params.id }, function(D){
						if(D.ok){
							THIS.success(THIS, D.data)
							THIS.loading()
						}else{
							THIS.res_pass = "";
							THIS.error(THIS, D.message)
						}
					}, "json");
				}
			}
		}
	}
</script>
<style>

</style>
